const LEVELS_RX_EXTERNAL_BASE_LINK = "https://www.levelsrx.com";
const VIMEO_EXTERNAL_BASE_LINK = "https://vimeo.com";

export const EXTERNAL_LINK = {
  HOME: LEVELS_RX_EXTERNAL_BASE_LINK,
  BLOG: "https://articles.levelsrx.com/",
  PRIVACY_AND_POLICY: `${LEVELS_RX_EXTERNAL_BASE_LINK}/privacy-policy`,
  TERMS_AND_CONDITIONS: `${LEVELS_RX_EXTERNAL_BASE_LINK}/terms-conditions`,
  OPENLOOP_TELEHEALTH_CONSENT: "https://openloophealth.com/telehealth-consent",
  CAREVALIDATE_TELEHEALTH_CONSENT:
    "https://support.careglp.com/support/solutions/articles/73000625395-medical-consent",
  TRACKING: "https://www.google.com/search?q=",
  SESH: "",
  COUNSELING_WAIVER: `${LEVELS_RX_EXTERNAL_BASE_LINK}/dietitianwaiver`,
  BOOK_NUTRITIONAL_COUNSELING: "",
  FAQ: {
    EN: `${LEVELS_RX_EXTERNAL_BASE_LINK}/#faq`,
    ES: `${LEVELS_RX_EXTERNAL_BASE_LINK}/#faq`,
  },
  FDA_DRUG_SHORTAGE:
    "https://dps.fda.gov/drugshortages/resolved/tirzepatide-injection",
  TUTORIALS: {
    MEDICATION_DOSING: `${VIMEO_EXTERNAL_BASE_LINK}/1064924958`,
    MEDICATION_REFILL: `${VIMEO_EXTERNAL_BASE_LINK}/1064925217`,
    COACHING_HUB: `${VIMEO_EXTERNAL_BASE_LINK}/1064924878`,
  },
  LONGEVITY_SHOP: `${LEVELS_RX_EXTERNAL_BASE_LINK}/longevity`,
  MEAL_DELIVERY: "",
} as const;
